import { render, staticRenderFns } from "./messages_list.vue?vue&type=template&id=513af08c&scoped=true&"
import script from "./messages_list.vue?vue&type=script&lang=ts&"
export * from "./messages_list.vue?vue&type=script&lang=ts&"
import style0 from "./messages_list.vue?vue&type=style&index=0&id=513af08c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513af08c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})
